import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { Unit } from 'src/app/units/models/unit';
import {
  UnitsTransmissionStatus,
  UnitWithTransmissionStatus,
} from 'src/app/units/models/unit-transmission-status';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';
import { DashboardService } from '../../service/dashboard.service';
interface Options {
  library: 'NGX-Charts' | 'chart.js';
}
interface UnitsTransmissionStatusWithOptions
  extends UnitsTransmissionStatus,
    Options {}

@Component({
  selector: 'app-charts-transmission-states',
  templateUrl: './charts-transmission-states.component.html',
  styleUrls: ['./charts-transmission-states.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartsTransmissionStatesComponent implements OnInit, OnDestroy {
  trackByTxStatus(
    index: number,
    item: UnitsTransmissionStatusWithOptions
  ): number {
    return item.transmissionStatusId;
  }
  unitTxStates$ = new BehaviorSubject<UnitsTransmissionStatusWithOptions[]>([]);
  unitTxStates: UnitsTransmissionStatusWithOptions[] = [];
  unitsTxStates$: Subscription | undefined;
  dasbroard$: Subscription | undefined;
  typeCharts: Options[];
  idOfTxStates: number[] = [];
  showMore: boolean = true;
  unitsToFilterGlobally: UnitWithTransmissionStatus[] = [];
  units: UnitWithTransmissionStatus[] = [];
  constructor(
    private unitTrasmitionService: UnitTransmissionStatusService,
    private dashboardService: DashboardService,
    private cdr: ChangeDetectorRef
  ) {
    this.dasbroard$ = dashboardService.getIdOfTxStates
      .pipe(
        map((_) => {
          this.idOfTxStates = _;
        }),
        tap(() => {
          this.startTxStates();
        })
      )
      .subscribe();
    this.typeCharts = [
      {
        library: 'NGX-Charts',
      },
      { library: 'chart.js' },
    ];
  }

  draggingItem: HTMLElement | null = null;

  more() {
    this.showMore = !this.showMore;
  }

  ngOnInit(): void {}
  ngOnDestroy(): void {
    this.unitsTxStates$?.unsubscribe();
    this.dasbroard$?.unsubscribe();
  }
  startTxStates() {
    this.unitsTxStates$?.unsubscribe();
    this.unitsTxStates$ = this.unitTrasmitionService.getUnitsTransmissionStates
      .pipe(
        map((_) =>
          _.filter((tx) => this.idOfTxStates.includes(tx.transmissionStatusId))
        ),
        tap((_) => {
          this.units = _.reduce(
            (A, T) => A.concat(T.unitsTransmissions),
            [] as UnitWithTransmissionStatus[]
          );
          const unitTxStatesWithOps: Options = {
            library: 'NGX-Charts',
          };
          const updatedStates = _.map((T) => ({
            ...T,
            ...unitTxStatesWithOps,
          }));
          this.unitTxStates$.next(updatedStates);
          this.unitTxStates = updatedStates;
          this.cdr.markForCheck();
        })
      )
      .subscribe();
  }

  onDragStart(event: DragEvent): void {
    const target = event.target as HTMLElement;
    this.draggingItem = target;
    setTimeout(() => target.classList.add('dragging'), 0);
  }
  onDragEnd(event: DragEvent): void {
    const target = event.target as HTMLElement;
    target.classList.remove('dragging');
    this.draggingItem = null;
  }
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    const targets = event.target as HTMLElement;
    const target = this.draggingItem;
    if (target && target.classList.contains('item')) {
      const list = targets.closest('.sortable-list') as HTMLElement;
      const draggingElement = list.querySelector('.dragging') as HTMLElement;
      const siblings = Array.from(
        list.querySelectorAll('.item:not(.dragging)')
      ) as HTMLElement[];
      const nextSibling = siblings.find((sibling: HTMLElement) => {
        const rect = sibling.getBoundingClientRect();
        return (
          event.clientY <= rect.top + rect.height / 2 &&
          event.clientX <= rect.left + rect.width / 2
        );
        // return (
        //   event.clientY <= sibling.offsetTop + sibling.offsetHeight / 2 &&
        //   event.clientX <= sibling.offsetLeft + sibling.offsetWidth / 2
        // );
      });
      if (draggingElement && list) {
        list.insertBefore(draggingElement, nextSibling || null);
      }
    }
  }
  onDragEnter(event: DragEvent): void {
    event.preventDefault();
  }
}
